import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { messagingDiagnosticsCanvasesForFilter } from "./constants";
import type { MessagingDiagnosticsCanvasFilterResult } from "./types";

export const getMessagingDiagnosticsCanvasesForFilter = reactQueryFetcherAdapter(
  messagingDiagnosticsCanvasesForFilter,
  (
    signal: AbortSignal,
    appGroupId: string,
    query: string,
    limit: number,
    // Empty string means "omit"; the adapter cache-key type excludes `undefined`.
    windowStart: string
  ): Promise<MessagingDiagnosticsCanvasFilterResult[]> => {
    return fetch(
      `/${appGroupId}/messaging_diagnostics/canvases_for_filter`,
      "GET",
      {
        query,
        limit,
        ...(windowStart ? { window_start: windowStart } : {}),
      },
      { signal }
    );
  }
);
